/** @jsxImportSource @emotion/react */

import React, {
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

import { DISABILITY_ID } from '../../const';
import { useOnboardingDataContext } from '../../context/OnboardingData';
import getNextQuestionId from '../../utils/getNextQuestionId';
import ButtonAnswer from '../ButtonAnswer';
import { CircleTick } from '../Icons';
import useStyles from './styles';

const getSelectedQuestion = questionOrder => {
  switch (true) {
    case JSON.parse(sessionStorage.getItem('ISJUSTPLAY')):
    case JSON.parse(sessionStorage.getItem('ISAGEUK')):
    case JSON.parse(sessionStorage.getItem('ISYOUTHCLUB')):
    case JSON.parse(sessionStorage.getItem('ISADULTCLUB')):
    case JSON.parse(sessionStorage.getItem('ISVOLUNTEER')) && questionOrder !== 5:
      return DISABILITY_ID;
    case JSON.parse(sessionStorage.getItem('ISVOLUNTEER')) && questionOrder === 5:
      return;
    default:
      return;
  }
};

const MultipleOptionalQuestion = React.forwardRef(
  (
    {
      readableId,
      answers,
      multiOptional,
      onAnswer,
      selectedAge,
      headerTitle,
      nextClickAnswer,
      questionOrder,
      setBothAnswerTrueFalse,
      bothAnswer,
      setPrevAnswerIdNull,
      prevAnswer,
      setNotselectAnswerTrueFalse,
      notselect,
      setSelectedAnswerTrueFalse,
      selectedAnswer,
    },
    genderRef
  ) => {
    const styles = useStyles();
    // will remove all/related below states comments once testing completed for PLAY-340
    // const [selectedAnswer, setSelectedAnswer] = useState();
    // const [optionalIsSelected, setOptionalIsSelected] = useState(false);
    const [isAnswerSelected, setIsAnswerSelected] = useState(false);
    const [questions, setQuestions] = useState();
    // const [prevAnswer, setPrevAnswer] = useState(false);
    // const [notselect, setNotselectAnswer] = useState();
    // const [bothAnswer, setBothAnswer] = useState(false);
    const {
      OnboardingContext,
      setOnboardingDataContext,
      arrowContext,
      setArrowFunction,
    } = useOnboardingDataContext();

    useEffect(() => {
      setQuestions(answers);
    }, [selectedAge, answers]);

    const { mandatory, optional } = questions || {};

    const getQuestionValue = () => {
      // Male or Female and Mixed combined
      if (selectedAnswer && questionOrder === 2) {
        return selectedAnswer?.combinedValue;
      }
      if (selectedAnswer && questionOrder === 4) {
        return selectedAnswer?.value || selectedAnswer?.title;
      }
      if (selectedAnswer && questionOrder === 5) {
        return selectedAnswer?.value || selectedAnswer?.title;
      }
      if (selectedAnswer && questionOrder === 3) {
        return selectedAnswer?.value;
      }
    };

    const selectAnswer = answer => {
      if (selectedAnswer?.answerId === answer.answerId) {
        // setSelectedAnswer(null);
        setSelectedAnswerTrueFalse(null);
        setIsAnswerSelected(false);
        setArrowFunction(false);
      } else {
        // setSelectedAnswer(answer);
        setSelectedAnswerTrueFalse(answer);
        setIsAnswerSelected(true);
        setArrowFunction(true);
      }
    };

    const selectDeselectAnswer = answer => {
      setArrowFunction(true);
      // setBothAnswer(false);
      setBothAnswerTrueFalse(false);
      // setNotselectAnswer(false);
      setNotselectAnswerTrueFalse(false);
      // setPrevAnswer(answer.answerId);
      setPrevAnswerIdNull(answer.answerId);

      if (answer.answerId === prevAnswer) {
        // setNotselectAnswer(true);
        setNotselectAnswerTrueFalse(true);
        setArrowFunction(false);
      }

      if (notselect === false && prevAnswer === answer.answerId) {
        // setSelectedAnswer(null);
        setSelectedAnswerTrueFalse(null);
        // setPrevAnswer(null);
        setPrevAnswerIdNull(null);
        setArrowFunction(false);
      } else {
        if (
          prevAnswer ? prevAnswer !== answer.answerId && !bothAnswer : false
        ) {
          setArrowFunction(true);
          // setNotselectAnswer(true);
          setNotselectAnswerTrueFalse(true);
          // setSelectedAnswer(multiOptional?.mandate[0]);
          setSelectedAnswerTrueFalse(multiOptional?.mandate[0]);

          if (selectedAnswer?.answerId !== 5) {
            // setBothAnswer(true);
            setBothAnswerTrueFalse(true);
          }
        } else {
          const filteranswer = mandatory.filter(answers => answers.answerId !== answer.answerId);
          // setSelectedAnswer(bothAnswer === true ? filteranswer[0] : answer);
          setSelectedAnswerTrueFalse(
            bothAnswer === true ? filteranswer[0] : answer
          );

          if (bothAnswer === true && filteranswer[0]) {
            setArrowFunction(true);
            // setPrevAnswer(filteranswer[0].answerId);
            setPrevAnswerIdNull(filteranswer[0].answerId);
          } else {
            // setNotselectAnswer(false);
            setNotselectAnswerTrueFalse(false);
          }
        }
      }
    };

    const selectedGenderAnswer = () => {
      const selectedQuestion = getSelectedQuestion(questionOrder);
      setTimeout(() => {
        onAnswer({
          answerData: { [readableId]: getQuestionValue() },
          nextQuestionId: getNextQuestionId({
            ageRanges: selectedAnswer
              ? selectedAnswer.ageRanges
              : optional.ageRanges,
            selectedAge,
            selectedQuestion,
          }),
        });
      }, 500);
    };

    // for passing this function to question component
    useImperativeHandle(genderRef, () => ({
      selectedGenderAnswer,
    }));

    useEffect(() => {
      setOnboardingDataContext({
        ...OnboardingContext,
        question: headerTitle,
        gender_group:
          selectedAnswer?.title === 'Female football'
            ? 'female'
            : selectedAnswer?.title === 'Female football'
            ? 'female | mixed'
            : selectedAnswer?.title === 'Male football'
            ? 'male'
            : selectedAnswer?.title === 'Male football'
            ? 'male | mixed'
            : undefined,
        step: 2,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [headerTitle, selectedAnswer]);

    // Helper to determine the selection logic path consistently
    const shouldUseSelectDeselect = qOrder => {
      const isVolunteer =
        JSON.parse(sessionStorage.getItem('ISVOLUNTEER')) === true;
      const isMinionboardingFalse =
        sessionStorage.getItem('ISMINIONBOARDING') === 'false';

      // This condition explicitly includes questionOrder 3 for multi-select behavior
      const isQuestion2or3 = qOrder === 2 || qOrder === 3;

      return (
        (isQuestion2or3 && isVolunteer) ||
        (isMinionboardingFalse && qOrder !== 4 && qOrder !== 5)
      );
    };

    const getIsSelected = answerId => {
      const isVolunteer =
        JSON.parse(sessionStorage.getItem('ISVOLUNTEER')) === true;
      if (isVolunteer) {
        if (bothAnswer === true) {
          return true;
        }
        if (notselect === true) {
          return false;
        }
        return selectedAnswer && selectedAnswer.answerId === answerId;
      }
      return arrowContext === true
        ? selectedAnswer && selectedAnswer.answerId === answerId
        : false;
    };

    return (
      <Fragment>
        {mandatory && (
          <ul role="none">
            {mandatory.map(answer => {
              const {
                answerId,
                analyticsId,
                title,
                value,
                combinedValue,
                answerType,
                ageRanges,
                ...rest
              } = answer;
              const isSelected = getIsSelected(answerId);
              return (
                <li key={answerId} css={styles.answer}>
                  <label css={styles.hiddenInputs(isSelected)}>
                    <input
                      type="checkbox"
                      value={title}
                      // Use the helper function here
                      onChange={() =>
                        shouldUseSelectDeselect(questionOrder)
                          ? selectDeselectAnswer(answer)
                          : selectAnswer(answer)
                      }
                      checked={!!isSelected}
                      name={readableId}
                    />
                    <ButtonAnswer
                      id={analyticsId}
                      css={styles.button(
                        isSelected,
                        bothAnswer,
                        isAnswerSelected
                      )}
                      icon={CircleTick}
                      isGender={true}
                      isSelected={isSelected === true ? true : bothAnswer}
                      // Use the helper function here as well, so mouse and keyboard actions align
                      onClick={() => {
                        shouldUseSelectDeselect(questionOrder)
                          ? selectDeselectAnswer(answer)
                          : selectAnswer(answer);
                      }}
                      tabIndex={-1}
                      {...rest}
                    >
                      {title}
                      {isSelected}
                    </ButtonAnswer>
                  </label>
                </li>
              );
            })}
            <button
              id={`question_${questionOrder}_next`}
              aria-label="Next"
              css={styles.buttonNext(arrowContext)}
              disabled={arrowContext === false ? true : false}
              onClick={() => {
                nextClickAnswer();
                selectedGenderAnswer();
                setArrowFunction(false);
                //setBothAnswer(false);
                setBothAnswerTrueFalse(false);
                // setNotselectAnswer(false);
                setNotselectAnswerTrueFalse(false);
                // setSelectedAnswer(null);
                setSelectedAnswerTrueFalse(null);
                // setPrevAnswer(null);
                setPrevAnswerIdNull(null);
              }}
            >
              Next
            </button>
          </ul>
        )}
      </Fragment>
    );
  }
);

export default MultipleOptionalQuestion;
